import { UserState } from "../models/UserState";

export function isAdminRole(user: UserState) {
    return user.payload?.role === "Admin";
}
